import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import android_45blocked_45global from "/app/app/middleware/android-blocked.global.ts";
import maintenance_45mode_45global from "/app/app/middleware/maintenance-mode.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  android_45blocked_45global,
  maintenance_45mode_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "terms-accepted": () => import("/app/app/middleware/terms-accepted.ts")
}